import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useParams, useNavigate } from 'react-router-dom';
import { auth, db } from './firebase'; 
import { 
    doc, getDoc, collection, query, where, getDocs, 
    updateDoc, or, orderBy 
} from 'firebase/firestore'; 
import { 
    MdLocationOn, MdEmail, MdPhone, MdWork, 
    MdSchool, MdPeople, MdApartment
} from 'react-icons/md';
import AppHeader from './AppHeader'; 

// --- Styled Components (உங்களது முந்தைய அதே டிசைன்) ---
const PageContainer = styled.div`
    padding: 20px; max-width: 900px; margin: 20px auto;
    background-color: #f7f9fc; border-radius: 8px; margin-top: 20px; 
`;

const ProfileCard = styled.div`
    background: white; border-radius: 12px; padding: 30px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05); display: flex;
    flex-direction: column; align-items: center; text-align: center;
`;

const ProfileImage = styled.img`
    width: 150px; height: 150px; border-radius: 50%;
    object-fit: cover; border: 4px solid #1a73e8; margin-bottom: 15px;
`;

const PostList = styled.div` margin-top: 30px; `;
const PostCard = styled.div`
    background: white; padding: 20px; border-radius: 8px;
    margin-bottom: 15px; border: 1px solid #dadce0;
`;

const ProfilePage = () => {
    const { id: urlParam } = useParams(); // URL-ல் வரும் பெயர் அல்லது ID
    const navigate = useNavigate();
    
    const [profileData, setProfileData] = useState(null);
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchProfileAndPosts = useCallback(async () => {
        setLoading(true);
        try {
            let targetUid = urlParam;
            let userData = null;

            // 1. பெயரில் உள்ள '-' குறியீட்டை நீக்கி தேடுகிறோம் (e.g., "Banupriya-M" -> "Banupriya M")
            const decodedName = decodeURIComponent(urlParam).replace(/-/g, ' ');

            // 2. முதலில் 'fullName' வைத்து Firestore-ல் தேடுகிறோம்
            const nameQuery = query(collection(db, "profiles"), where("fullName", "==", decodedName));
            const nameSnap = await getDocs(nameQuery);

            if (!nameSnap.empty) {
                userData = nameSnap.docs[0].data();
                targetUid = userData.uid;
            } else {
                // 3. பெயர் கிடைக்கவில்லை என்றால், அது UID-யாக இருக்கலாம் என நேரடியாகத் தேடுகிறோம்
                const docRef = doc(db, "profiles", urlParam);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    userData = docSnap.data();
                    targetUid = urlParam;
                }
            }

            if (userData) {
                setProfileData(userData);
                // அந்த பயனரின் பதிவுகளை (Posts) எடுக்கிறோம்
                const postsQuery = query(
                    collection(db, "posts"),
                    where("userId", "==", targetUid),
                    orderBy("createdAt", "desc")
                );
                const postsSnap = await getDocs(postsQuery);
                setPosts(postsSnap.docs.map(d => ({ id: d.id, ...d.data() })));
            }
        } catch (error) {
            console.error("Error fetching profile:", error);
        } finally {
            setLoading(false);
        }
    }, [urlParam]);

    useEffect(() => {
        fetchProfileAndPosts();
    }, [fetchProfileAndPosts]);

    if (loading) return <div style={{textAlign: 'center', marginTop: '50px'}}>Loading Profile...</div>;
    
    if (!profileData) return <div style={{textAlign: 'center', marginTop: '50px'}}>User not found.</div>;

    return (
        <>
            <AppHeader />
            <PageContainer>
                <ProfileCard>
                    <ProfileImage src={profileData.profileImageUrl || "/placeholder.png"} alt="Profile" />
                    <h1>{profileData.fullName}</h1>
                    <p style={{color: '#5f6368'}}>{profileData.profession || profileData.mainRole}</p>
                    
                    <div style={{display: 'flex', gap: '20px', marginTop: '15px', flexWrap: 'wrap', justifyContent: 'center'}}>
                        {profileData.email && <p><MdEmail color="#1a73e8"/> {profileData.email}</p>}
                        {profileData.city && <p><MdLocationOn color="#1a73e8"/> {profileData.city}, {profileData.country}</p>}
                    </div>
                </ProfileCard>

                <PostList>
                    <h3>Recent Posts</h3>
                    {posts.length > 0 ? (
                        posts.map(post => (
                            <PostCard key={post.id}>
                                {post.text && <p>{post.text}</p>}
                                {post.mediaUrl && <img src={post.mediaUrl} style={{width: '100%', borderRadius: '8px'}} alt="post" />}
                                <small style={{color: '#888'}}>
                                    Posted on: {post.createdAt?.toDate ? post.createdAt.toDate().toLocaleDateString() : 'Recent'}
                                </small>
                            </PostCard>
                        ))
                    ) : (
                        <p>{profileData.fullName} has no posts yet.</p>
                    )}
                </PostList>
            </PageContainer>
        </>
    );
};

export default ProfilePage;